<template>
  <div
    class="modal align-items-center"
    :class="{'d-flex': show}"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header align-items-center">
          <h5 class="mb-0 text-main">
            Delete this bucket
          </h5>
          <a @click="onClose()">
            <GjIcon name="Close" />
          </a>
        </div>
        <div
          class="modal-body"
          :class="{'filter': savingChanges}"
        >
          <p class="text-secondary">
            Destroying a bucket will schedule the Bucket and all the objects inside to be permanently destroyed.
          </p>
          <custom-alert
            icon-name="InfoAlt"
            icon-color="#e34850"
          >
            Warning: Destroying a Bucket can take several days depending on the amount of data. During this time, the name of the Bucket cannot be reused and you will NOT be billed for the space.
          </custom-alert>
          <p class="text-secondary mb-3">
            Confirm you want to permanently destroy this Bucket by entering its name below:
          </p>

          <validation-observer
            ref="deleteRules"
            tag="form"
          >
            <validation-provider vid="bucket_name">
              <input-field
                label="Bucket name"
                label-position="top"
                name="bucket_name"
              >
                <b-form-input
                  id="bucket_name"
                  :value="bucket_name"
                  disabled
                />
              </input-field>
            </validation-provider>
            <validation-provider
              #default="{ errors }"
              name="Bucket name"
              rules="required|confirmed:bucket_name"
              class="w-100"
            >
              <input-field
                name="bucketName"
                label="Enter the name of the Bucket to confirm deletion"
                label-position="top"
                :error="errors.length ? errors[0] : null"
              >
                <b-form-input
                  id="bucketName"
                  v-model="bucketName"
                  :state="errors.length > 0 ? false:null"
                />
              </input-field>
            </validation-provider>
          </validation-observer>
        </div>
        <div
          class="modal-footer"
          :class="{'filter': savingChanges}"
        >
          <b-button
            variant="bg-white"
            @click="onClose()"
          >
            Cancel
          </b-button>
          <b-button
            variant="danger"
            @click="onDelete()"
          >
            Delete
          </b-button>
        </div>
        <template v-if="savingChanges">
          <div class="loading">
            <b-spinner
              variant="primary"
              label="Text Centered"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, confirmed } from '@validations'
import InputField from '@/components/form/InputField.vue'

export default {
  name: 'DeleteConfirmation',
  components: {
    ValidationProvider,
    ValidationObserver,
    InputField,
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    name: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      required,
      confirmed,
      bucketName: '',
      bucket_name: null,
    }
  },
  computed: {
    savingChanges() {
      return this.$store.state.accountBuckets.deletingBucket
    },
  },
  created() {
    this.bucket_name = this.name ? this.name : this.$store.state.accountBuckets.bucket.name
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    async onDelete() {
      const isValid = await this.$refs.deleteRules.validate()
      if (isValid) {
        this.$emit('delete', this.bucketName)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.modal {
  .modal-header {
    h5 {
      font-size: 16px;
    }
  }
  .loading {
    position: absolute;
    height: 100%;
    width: 100%;
  }
  .filter {
    filter: blur(1px);
  }
}
</style>
